import React from 'react';

import { FileDownload as FileDownloadIcon } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';

import {
  GenerateVerificationRequestsReportMutationVariables,
  useGenerateVerificationRequestsReportMutation,
  VerificationRequestsReportFormat,
} from 'src/api';
import { TableActionButton } from 'src/components/table';
import { downloadFileByDownloadUrl } from 'src/utils/file';

interface VerificationRequestsReportExportButtonProps {
  where: GenerateVerificationRequestsReportMutationVariables['where'];
  orderBy: GenerateVerificationRequestsReportMutationVariables['orderBy'];
  disabled?: boolean;
}

export const VerificationRequestsReportExportButton: React.FC<
  VerificationRequestsReportExportButtonProps
> = ({ where, orderBy, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [generateReport, { loading }] = useGenerateVerificationRequestsReportMutation();

  const handleExport = React.useCallback(
    async (format: VerificationRequestsReportFormat) => {
      setAnchorEl(null);

      const { data } = await generateReport({ variables: { where, orderBy, format } });
      const file = data?.generateVerificationRequestsReport;

      if (file?.downloadUrl) {
        downloadFileByDownloadUrl(file.downloadUrl, file.filename);
      }
    },
    [generateReport, where, orderBy],
  );

  return (
    <React.Fragment>
      <TableActionButton
        icon={<FileDownloadIcon />}
        disabled={disabled || loading}
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        Export
      </TableActionButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => handleExport(VerificationRequestsReportFormat.Xlsx)}>
          Export as XLSX
        </MenuItem>
        <MenuItem onClick={() => handleExport(VerificationRequestsReportFormat.Csv)}>
          Export as CSV
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};
